<template>
  <v-container>
    <!-- <vuescroll
      :ops="{
        bar: {
          background: '#bacfcec0',
          keepShow: true,
        },
      }"
    > -->
    <v-data-table
      :headers="registerHeaders"
      :items="registerList"
      class="elevation-0"
      :loading="isLoadingRegisters"
      :no-data-text="noDataText"
      hide-default-footer
    >
      <template v-slot:[`item.status_register_id`]="{ item }">
        {{ showStatusName(item.status_register_id) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="openCallDialog(item)"
          >
            <v-icon>mdi-phone</v-icon>
          </v-btn>
        </v-hover>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="openChangeStatusDialog(item)"
          >
            <v-icon>mdi-star</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>
    <!-- </vuescroll> -->

    <dialer-dialog
      v-if="isOpenDialer"
      :isOpenDialer="isOpenDialer"
      :item="itemToDialer"
      :onSubmit="getCallNow"
      @dialog:change="closeDialerDialog"
    ></dialer-dialog>

    <auto-call-dialog
      v-if="isOpenAutoDialer"
      :isOpenAutoDialer="isOpenAutoDialer"
      :itemToCall="itemToCall"
      :onSubmit="getCallNow"
      @dialog:change="closeAutoDialerDialog"
      @finished:call="getTypification"
    ></auto-call-dialog>

    <change-status
      v-if="isOpenChangeStatusDialog"
      :isOpen="isOpenChangeStatusDialog"
      :numberSelected="numberSelected"
      :dataToEdit="dataToEdit"
      :statusList="statusList"
      :campaignId="campaignId"
      @dialog:change="closeChangeStatusDialog"
    ></change-status>
  </v-container>
</template>

<script>
import vuescroll from "vuescroll";
import { mapState } from "vuex";

import { PbxHttpClient } from "@/services/httpclient";
import DialerDialog from "./DialerDialog.vue";
import ChangeStatus from "./ChangeStatus.vue";
import AutoCallDialog from "./AutoCallDialog.vue";

export default {
  props: {
    campaignId: {
      type: Number
    },
    isCustomSearch: {
      type: Boolean
    },
    payloadSearch: {
      type: Object
    },
    campaignType: {
      type: String
    },
    clientId: {}
  },
  components: { vuescroll, DialerDialog, ChangeStatus, AutoCallDialog },

  data() {
    return {
      isLoadingRegisters: true,
      isOpenChangeStatusDialog: false,
      isOpenDialer: false,
      isOpenAutoDialer: false,
      numberSelected: null,
      registerId: null,
      phoneToCall: null,
      queueToCall: null,
      dataToEdit: {},
      itemToDialer: {},
      itemToCall: {},
      statusList: [],
      registerList: [],
      registerHeaders: [
        { text: "Nombre", value: "name", width: "30%" },
        { text: "DNI", value: "dni", width: "15%" },
        { text: "Teléfono", value: "llamar_telefono", width: "20%" },
        { text: "Status", value: "status_register_id", width: "20%" },
        { text: "Acciones", value: "action", width: "15%" }
      ],
      typificationData: { temporaryTableId: null, queueNumberSelected: null }
    };
  },
  computed: {
    noDataText() {
      return this.isCustomSearch
        ? "No hay registros que coincidan con la búsqueda"
        : "No existen campañas";
    },

    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },

    ...mapState({
      // Breaks: state => state.breaks.allBreaks,
      extensionVariableValue: (state) => state.passport.user.variable
    })
  },
  created() {
    this.getStatus();
    if (this.isCustomSearch) this.getCustomRegisters();
    else this.getRegisters();
  },

  watch: {
    isCustomSearch(val) {
      if (val) this.getCustomRegisters();
    },
    payloadSearch: {
      handler() {
        this.getCustomRegisters();
      },
      deep: true
    }
  },

  methods: {
    openChangeStatusDialog(item = false) {
      this.dataToEdit = item || this.registerList[0];
      this.isOpenChangeStatusDialog = true;
    },

    closeChangeStatusDialog(newStatus) {
      if (newStatus.status) this.registerList = [newStatus];
      this.isOpenChangeStatusDialog = false;
      this.dataToEdit = {};
      // this.closeRegister(newStatus.id);
      this.getRegisters();
    },
    openAutoCallDialog() {
      this.itemToCall = {
        call_number: this.phoneToCall,
        queue: this.queueToCall
      };

      // console.log("aqui phone", this.phoneToCall);
      // console.log("aqui se pone", this.itemToCall);

      this.isOpenAutoDialer = true;
    },

    openCallDialog(item) {
      this.itemToDialer = item;
      this.isOpenDialer = true;
    },
    closeDialerDialog() {
      this.isOpenDialer = false;
      this.itemToDialer = {};
    },
    closeAutoDialerDialog() {
      this.isOpenAutoDialer = false;
      this.itemToCall = {};
    },
    showStatusName(id) {
      return this.statusList.find((el) => el.id === id)?.name;
    },

    async getRegisters() {
      this.isLoadingRegisters = true;
      try {
        const { data } = await PbxHttpClient.get(
          // `/campaign/assign_register/${this.campaignId}`
          `campaign/return_register?client_id=${this.clientId}&campaign_id=${this.campaignId}`
        );
        if (typeof data !== "object" || Object.keys(data).length === 0)
          this.registerList = [];
        else {
          this.registerList = data.data;
          this.phoneToCall = data.data[0].llamar_telefono || "";
          this.queueToCall = data.queue.number || null;

          if (this.phoneToCall !== "") {
            this.openAutoCallDialog();
            this.openChangeStatusDialog();
            this.closeAutoDialerDialog();
          }
        }
      } catch (err) {
        this.$snotify.error("Hubo un error cargando los registros", "Error");
        // console.log(err);
      }
      this.isLoadingRegisters = false;
    },

    async getCustomRegisters() {
      this.isLoadingRegisters = true;
      try {
        const { data } = await PbxHttpClient.post(
          `campaign/search_register/${this.campaignId}`,
          this.payloadSearch
        );
        // console.log("details", data);
        this.registerList = data.data.length > 1 ? [data?.data[0]] : data?.data;
      } catch (err) {
        this.$snotify.error(
          "Hubo un error o no se encontraron registros",
          "Error"
        );
        // console.log(err);
      }
      this.isLoadingRegisters = false;
    },

    async getCallNow(number) {
      // console.log("phone selected:", number);
      try {
        this.number = this.phoneToCall;
        await PbxHttpClient.get(`campaign/call_number/${number}`);
        this.$snotify.success("Llamada realizada con éxito.", "¡Hecho!");
        this.openChangeStatusDialog();
        this.closeDialerDialog();
      } catch (err) {
        // console.log("error calling now:", err);
        if (err.response)
          this.$snotify.error(err.response?.data?.error, "¡Error!");
        else
          this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
      }
    },
    async getStatus() {
      try {
        const { data } = await PbxHttpClient.get(`campaign/status_register`);
        this.statusList = data;
      } catch (err) {
        // console.log("error getting status:", err);
        this.$snotify.error(
          "Hubo un error buscando los estados, intente mas tarde.",
          "¡Error!"
        );
      }
    },
    // async closeRegister(registerId) {
    //   try {
    //     await PbxHttpClient.get(`campaign/remove_register/${registerId}`);
    //   } catch (err) {
    //     // console.log("error calling now:", err);
    //     if (err.response)
    //       this.$snotify.error(err.response?.data?.error, "¡Error!");
    //     else
    //       this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
    //   }
    // },
    async getTypification(payload) {
      try {
        // console.log("payload", payload);

        const { data } = await PbxHttpClient.get(`/typing/typing_call/get`, {
          params: {
            extension: this.hasRTC ? undefined : this.extensionVariableValue
          }
        });
        const item = data.data.find(
          (call) => call.call_number === payload.call_number
        );
        this.typificationData = {
          temporaryTableId: item.id,
          queueNumberSelected: payload.queue
        };
        this.isOpenTypification = true;
      } catch (error) {
        // console.log(error);
        this.$snotify.error(
          "Hubo un error buscando la tipificacion.",
          "¡Error!"
        );
      }
    }
  }
};
</script>

<style></style>
